module.exports = __webpack_public_path__ + "img/skin-redness-result-ru.fca41e13.jpg";